import {
    getMeta,
    getMetaOrFail,
} from '@precon-tools-suite-by-shared/browser-utils';

/**
 * Get the base URL for the importer API, guaranteed to end with '/api'.
 * @param {string} [fallback] - The fallback URL if the meta tag is not present.
 * @returns {string} - The base URL for the importer API.
 */
export function getImporterBaseUrl(fallback?: string): string {
    const basePath = getBasePath(fallback);

    // TODO: This is a temporary fix to make sure the base path ends with /api
    // HACK: This is a temporary fix to make sure the base path ends with /api
    const withApi = ensureEndsWithApi(basePath);
    return withApi;
}

/**
 * Get the base path from the meta tag or fallback.
 * @param {string} [fallback] - The fallback URL if the meta tag is not present.
 * @returns {string} - The base path.
 */
function getBasePath(fallback?: string): string {
    const fallbackIsGiven = typeof fallback === 'string' && fallback.length > 0;
    if (fallbackIsGiven) {
        return getMeta('importapi-http-endpoint') ?? fallback;
    } else {
        return getMetaOrFail('importapi-http-endpoint');
    }
}

/**
 * Ensure the base path ends with '/api'.
 * @param {string} basePath - The base path.
 * @returns {string} - The base path ending with '/api'.
 */
export function ensureEndsWithApi(basePath: string): string {
    if (!basePath.endsWith('/api')) {
        basePath = basePath.replace(/\/+$/, ''); // Remove trailing slashes
        basePath += '/api';
    }
    return basePath;
}
